/**
 * Where the job is: city + state, asked on every homeowner request so pros can judge the drive.
 * Street address is not collected; the pro gets it when they reach out.
 */

/** Tri-state service area. */
export const SERVICE_AREA_STATES = ['KY', 'OH', 'IN'];

const LAST_LOCATION_SESSION_KEY = 'nky_connect_last_service_location';

/** "Florence, KY", or '' when the city is blank. */
export function formatServiceLocation({ city, state } = {}) {
  const cityTrim = String(city || '').trim();
  if (!cityTrim) return '';
  const stateTrim = String(state || '').trim();
  return stateTrim ? `${cityTrim}, ${stateTrim}` : cityTrim;
}

/** Field errors for the location inputs; both fields are required. */
export function getServiceLocationErrors({ city, state } = {}) {
  return {
    city: String(city || '').trim() ? '' : 'Enter the city where the job is.',
    state: SERVICE_AREA_STATES.includes(state) ? '' : 'Choose a state.',
  };
}

export function isServiceLocationComplete(location) {
  const errors = getServiceLocationErrors(location);
  return !errors.city && !errors.state;
}

/** Copies city/state onto a wizard state's form data and readable summary. */
export function withServiceLocation(wizardState, { city, state }) {
  if (!wizardState) return wizardState;
  const cityTrim = String(city || '').trim();
  return {
    ...wizardState,
    formData: { ...wizardState.formData, city: cityTrim, state },
    requestSummary: {
      ...wizardState.requestSummary,
      location: formatServiceLocation({ city: cityTrim, state }),
    },
  };
}

/** Last location sent from this tab, to prefill the next request. */
export function readLastServiceLocation() {
  try {
    const parsed = JSON.parse(sessionStorage.getItem(LAST_LOCATION_SESSION_KEY) || 'null');
    if (!parsed || typeof parsed !== 'object') return null;
    return {
      city: String(parsed.city || ''),
      state: SERVICE_AREA_STATES.includes(parsed.state) ? parsed.state : '',
    };
  } catch {
    return null;
  }
}

export function writeLastServiceLocation({ city, state }) {
  try {
    sessionStorage.setItem(
      LAST_LOCATION_SESSION_KEY,
      JSON.stringify({ city: String(city || '').trim(), state }),
    );
  } catch {
    /* ignore quota / private mode */
  }
}
